__turbopack_context__.v({
  "fadeIn": "styles-module__DXVSSa__fadeIn",
  "tabContainer": "styles-module__DXVSSa__tabContainer",
});
